<script setup lang="ts">
import AskHelp from '../AskHelp.vue';
import CartIcon from './CartIcon.vue';
import DrawerMenu from './DrawerMenu.vue';
const auth = useAuthStore();
</script>

<template>
<div class="flex items-center justify-between px-4 py-2">
    <div class="flex items-center">
        <NuxtLink to="/shops">
        <img
          src="assets/images/logo.png"
          alt="Annza Logo"
          width="150"
          class="h-auto"
        >
      </NuxtLink>
    </div>
    <div class="flex items-center gap-2">
      <AskHelp />
      <NuxtLink :to="auth.shopId ? '/shops/' + auth.shopId : '/shops'">
        <CartIcon />
      </NuxtLink>
      <DrawerMenu />
    </div>
</div>
</template>

